<template>
  <el-row
    class="magazine__row home__section"
    :gutter="30"
  >
    <el-col
      :xs="{ span: 11, offset: 1 }"
      :sm="{ span: 8, offset: 4 }"
      :md="{ span: 7, offset: 5 }"
      :lg="{ span: 7, offset: 5 }"
      :xl="{ span: 7, offset: 5 }"
    >
      <router-link :to="{ name: 'resources.lt' }" class="magazine__link">
          <img :src="ltCoverImage" class="magazine__image">

          <div class="magazine__title">
            <hgroup>
              <h3 class="magazine__title-heading">Let's Talk in English</h3>
              <h4 class="magazine__title-heading">大家說英語</h4>
            </hgroup>

            <span class="magazine__date">{{ this.currentYearMonth }}</span>
          </div>
      </router-link>
    </el-col>

    <el-col
      :xs="{ span: 11, offset: 0 }"
      :sm="{ span: 8, offset: 0 }"
      :md="{ span: 7, offset: 0 }"
      :lg="{ span: 7, offset: 0 }"
      :xl="{ span: 7, offset: 0 }"
    >
      <router-link :to="{ name: 'resources.sc' }" class="magazine__link">
          <img :src="scCoverImage" class="magazine__image">

          <div class="magazine__title">
            <hgroup>
              <h3 class="magazine__title-heading">Studio Classroom</h3>
              <h4 class="magazine__title-heading">空中英語教室</h4>
            </hgroup>

            <span class="magazine__date">{{ this.currentYearMonth }}</span>
          </div>
      </router-link>
    </el-col>
  </el-row>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      src: 'http://www.studioclassroom.com/img/cover/',
      year: moment().format('YYYY'),
      year1: moment().add(1, 'Y').format('YYYY'),
      month: moment().format('MM'),
      month1: moment().add(1,"M").format('MM'),
      monthAlt: moment().format('M'),
      date: moment().format('D')
    }
  },
  computed: {
    ltCoverImage () {
      if(moment().format('D')>20){
	    if (this.month == 12){
          return `${this.src + this.year1}/LT${this.year1 + this.month1}_cover.jpg`
		} else {
		  return `${this.src + this.year}/LT${this.year + this.month1}_cover.jpg`
		}
      } else {
	    if (this.month == 12){
          return `${this.src + this.year}/LT${this.year + this.month}_cover.jpg`
        } else {
		  return `${this.src + this.year}/LT${this.year + this.month}_cover.jpg`
		}
      } 
    },
    scCoverImage () {
      if(moment().format('D')>20){
	    if (this.month == 12){
          return `${this.src + this.year1}/SC${this.year1 + this.month1}_cover.jpg`
		} else {
		  return `${this.src + this.year}/SC${this.year + this.month1}_cover.jpg`
		}
      } else {
	    if (this.month == 12){
          return `${this.src + this.year}/SC${this.year + this.month}_cover.jpg`
		} else {
		  return `${this.src + this.year}/SC${this.year + this.month}_cover.jpg`
		}
      }
    },
    currentYearMonth () {
      //console.log(moment().format('YYYY-MM-DD'))
      let mm = moment().format('YYYY-MM-DD')
      //let vv = mm.substr(5,2);
      if (this.date > 20){
        if (this.month== 12){
          return `${this.year1} 年 ${this.month1} 月`
        } else {
          return `${this.year} 年 ${this.month1} 月`
        }
      } else {
        //console.log("<20")
        if (this.month == 12){
          return `${this.year} 年 ${this.month} 月`
        } else {
          return `${this.year} 年 ${this.month} 月`
        }

      }
      
    }
  }
}
</script>